import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// UK Flag SVG
const UKFlag = () => (
  <svg width="24" height="16" viewBox="0 0 60 40" className="flag-icon">
    <clipPath id="uk-clip">
      <rect width="60" height="40" rx="2"/>
    </clipPath>
    <g clipPath="url(#uk-clip)">
      <rect width="60" height="40" fill="#012169"/>
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8"/>
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="4"/>
      <path d="M30,0 V40 M0,20 H60" stroke="#fff" strokeWidth="12"/>
      <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="6"/>
    </g>
  </svg>
);

// Netherlands Flag SVG
const NLFlag = () => (
  <svg width="24" height="16" viewBox="0 0 60 40" className="flag-icon">
    <rect width="60" height="40" fill="#21468B" rx="2"/>
    <rect width="60" height="26.67" fill="#fff"/>
    <rect width="60" height="13.33" fill="#AE1C28"/>
  </svg>
);

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English', Flag: UKFlag },
    { code: 'nl', name: 'Nederlands', Flag: NLFlag }
  ];

  const currentLang = languages.find(l => l.code === language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLanguageSelect = (langCode) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button 
        className="language-selector-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select language"
      >
        <currentLang.Flag />
        <span className="lang-code">{currentLang.code.toUpperCase()}</span>
        <ChevronDown size={14} className={`lang-arrow ${isOpen ? 'rotate' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`language-option ${language === lang.code ? 'active' : ''}`}
              onClick={() => handleLanguageSelect(lang.code)}
            >
              <lang.Flag />
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
